import styled from 'styled-components';
import createStyles from '@mui/styles/createStyles';
import fonts from '@/customComponents/css/fonts';

export const SearchIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const styles = (theme) =>
  createStyles({
    root: {
      margin: '0px 4px',
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 30,
      width: 412
    },
    input: {
      marginLeft: 8,
      paddingTop: 4,
      flex: 1,
      fontFamily: fonts.fontRegular,

      '.input': {
        height: 20
      },
      '& input[type=number]': {
        '-moz-appearance': 'textfield'
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      }
    },
    button: {
      padding: 10,
      margin: '0 !important'
    },
    divider: {
      width: 1,
      height: 20,
      margin: 4,
      background: theme.palette.grey[400]
    }
  });
